// Keep in sync with api/aircraft-taxonomy.mjs (web Docker build only includes web/).
function cleanText(value) {
  if (value === undefined || value === null) return "";
  return String(value).trim();
}

function normaliseLookupKey(value) {
  return cleanText(value)
    .replace(/[\u2018\u2019\u2032`]/g, "'")
    .replace(/\s+/g, " ");
}

/** Exact aircraft_type → model family (production fleet). */
export const MODEL_FAMILY_BY_TYPE = {
  "737-700": "B737 NG",
  "737-800": "B737 NG",
  "737-900ER": "B737 NG",
  "737-8": "B737 MAX",
  "737-9": "B737 MAX",
  "777F": "B777",
  "787-8": "B787",
  "787-9": "B787",
  "A220-300 (BD-500-1A11)": "A220",
  "A320-214": "A320ceo",
  "A320-216": "A320ceo",
  "A320-232": "A320ceo",
  "A320-233": "A320ceo",
  "A321-211": "A320ceo",
  "A321-231": "A320ceo",
  "A320-251N": "A320neo",
  "A320-271N": "A320neo",
  "A321-251N": "A320neo",
  "A321-251NX": "A320neo",
  "A321-253NX": "A320neo",
  "A321-271N": "A320neo",
  "A321-271NX": "A320neo",
  "A330-223": "A330",
  "A330-243": "A330",
  "A330-302": "A330",
  "A330-323": "A330",
  "A330-343": "A330",
  "A330-900NEO": "A330neo",
  "A330-941": "A330neo",
  "A350-941": "A350",
  "ATR 42-500": "ATR 42",
  "ATR-42-500": "ATR 42",
  "ATR 42-500 '600 version'": "ATR 42",
  "ATR 72-212A": "ATR 72",
  "ATR 72-212A '600 version'": "ATR 72",
  "ATR-72-600": "ATR 72",
  "DHC-8-400": "Dash 8",
  "ERJ 190-100": "E-Jet",
};

const MODEL_FAMILY_PATTERNS = [
  { test: /ATR[\s-]?42/i, family: "ATR 42" },
  { test: /ATR[\s-]?72/i, family: "ATR 72" },
  { test: /^737-[789]/i, family: "B737 NG" },
  { test: /^737-[89]$/i, family: "B737 MAX" },
  { test: /^787/i, family: "B787" },
  { test: /^777/i, family: "B777" },
  { test: /^A220/i, family: "A220" },
  { test: /^A321-2(51|53|71)/i, family: "A320neo" },
  { test: /^A320-2(51|71)/i, family: "A320neo" },
  { test: /^A3(20|21)-/i, family: "A320ceo" },
  { test: /^A330-9/i, family: "A330neo" },
  { test: /^A330/i, family: "A330" },
  { test: /^A350/i, family: "A350" },
  { test: /^DHC-8/i, family: "Dash 8" },
  { test: /^ERJ/i, family: "E-Jet" },
];

/** Exact engine_model → engine family. */
export const ENGINE_FAMILY_BY_MODEL = {
  "PW127M": "PW100",
  "PW127XT-M": "PW100",
  "PW127F": "PW100",
  "CFM56-5B4/3": "CFM56-5B",
  "CFM56-5B3/3": "CFM56-5B",
  "CFM56-5B6/3": "CFM56-5B",
  "CFM56-5B4/P": "CFM56-5B",
  "CFM56-7B26E": "CFM56-7B",
  "CFM56-7B26/3": "CFM56-7B",
  "CFM56-7B26": "CFM56-7B",
  "CFM56-7B24E": "CFM56-7B",
  "CFM56-7B27E": "CFM56-7B",
  "CFM56-7B24/3": "CFM56-7B",
  "CFM56-7B24": "CFM56-7B",
  "CFM56-7B22/3": "CFM56-7B",
  "LEAP-1B27": "LEAP-1B",
  "LEAP-1B25": "LEAP-1B",
  "LEAP-1B28": "LEAP-1B",
  "LEAP-1B28B1": "LEAP-1B",
  "LEAP-1A26": "LEAP-1A",
  "LEAP-1A32": "LEAP-1A",
  "LEAP-1A33": "LEAP-1A",
  "V2527-A5 Select One": "V2500",
  "V2527-A5": "V2500",
  "V2527E-A5 Select Two": "V2500",
  "V2527-A5 Select Two": "V2500",
  "V2533-A5 Select Two": "V2500",
  "V2533-A5": "V2500",
  "V2533-A5 Select One": "V2500",
  "PW1133G-JM": "PW GTF",
  "PW1127G-JM": "PW GTF",
  "PW1127GA-JM": "PW GTF",
  "PW1133GA-JM": "PW GTF",
  "PW1524G": "PW GTF",
  "GE90-110B1L": "GE90",
  "RB211 TRENT 772B-60": "Trent 700",
  "Trent 1000-D3": "Trent 1000",
  "Trent 1000-D2": "Trent 1000",
  "Trent XWB-84": "Trent XWB",
  "Trent 7000": "Trent 7000",
  "PW150A": "PW150",
  "PW4168A": "PW4000",
  "GEnx-1B74/75/P2": "GEnx",
  "GEnx-1B70/75/P2": "GEnx",
  "CF6-80E1A4/B": "CF6",
};

const ENGINE_FAMILY_PATTERNS = [
  { test: /^PW127/i, family: "PW100" },
  { test: /^CFM56-5B/i, family: "CFM56-5B" },
  { test: /^CFM56-7B/i, family: "CFM56-7B" },
  { test: /^LEAP-1B/i, family: "LEAP-1B" },
  { test: /^LEAP-1A/i, family: "LEAP-1A" },
  { test: /^V25(27|33)/i, family: "V2500" },
  { test: /^PW11(27|33)/i, family: "PW GTF" },
  { test: /^PW1524/i, family: "PW GTF" },
  { test: /^GE90/i, family: "GE90" },
  { test: /Trent 772|RB211/i, family: "Trent 700" },
  { test: /Trent 1000/i, family: "Trent 1000" },
  { test: /Trent XWB/i, family: "Trent XWB" },
  { test: /Trent 7000/i, family: "Trent 7000" },
  { test: /^PW150/i, family: "PW150" },
  { test: /^PW4168/i, family: "PW4000" },
  { test: /^GEnx/i, family: "GEnx" },
  { test: /^CF6/i, family: "CF6" },
];

export function inferModelFamily(aircraftType) {
  const key = normaliseLookupKey(aircraftType);
  if (!key) return null;
  if (MODEL_FAMILY_BY_TYPE[key]) return MODEL_FAMILY_BY_TYPE[key];
  for (const [exact, family] of Object.entries(MODEL_FAMILY_BY_TYPE)) {
    if (normaliseLookupKey(exact) === key) return family;
  }
  for (const rule of MODEL_FAMILY_PATTERNS) {
    if (rule.test.test(key)) return rule.family;
  }
  return null;
}

export function inferEngineFamily(engineModel) {
  const key = normaliseLookupKey(engineModel);
  if (!key) return null;
  if (ENGINE_FAMILY_BY_MODEL[key]) return ENGINE_FAMILY_BY_MODEL[key];
  for (const [exact, family] of Object.entries(ENGINE_FAMILY_BY_MODEL)) {
    if (normaliseLookupKey(exact) === key) return family;
  }
  for (const rule of ENGINE_FAMILY_PATTERNS) {
    if (rule.test.test(key)) return rule.family;
  }
  return null;
}

export function resolveModelFamily(aircraftType, storedFamily = null) {
  const stored = cleanText(storedFamily);
  if (stored) return stored;
  return inferModelFamily(aircraftType) || cleanText(aircraftType) || "—";
}

export function resolveEngineFamily(engineModel, storedFamily = null) {
  const stored = cleanText(storedFamily);
  if (stored) return stored;
  return inferEngineFamily(engineModel) || cleanText(engineModel) || "—";
}

export function aircraftModelFamily(aircraft) {
  if (!aircraft || typeof aircraft !== "object") return "—";
  const series = cleanText(aircraft.aircraft_series || aircraft.aircraftSeries);
  if (series) return series;
  return resolveModelFamily(
    aircraft.aircraft_type || aircraft.aircraftType || aircraft.type,
    aircraft.model_family || aircraft.modelFamily
  );
}

export function aircraftEngineFamily(aircraft) {
  if (!aircraft || typeof aircraft !== "object") return "—";
  const series = cleanText(aircraft.engine_series || aircraft.engineSeries);
  if (series) return series;
  return resolveEngineFamily(
    aircraft.engine_model || aircraft.engineModel,
    aircraft.engine_family || aircraft.engineFamily
  );
}

/** Stable internal key for duplicate MSN rows (matches XRM import). */
export function fleetIdentKey(msn, aircraftType, aircraftSeries = null) {
  const m = cleanText(msn);
  if (!m) return "";
  const t = cleanText(aircraftType || aircraftSeries).toUpperCase();
  let family = "AC";
  if (t.includes("ATR")) family = "ATR";
  else {
    const match = t.match(/\b(A\d{3}|B\d{3,4}|E\d{3}|CRJ|ERJ|Q\d{3}|DH\d)\b/);
    if (match) family = match[1];
    else if (t.includes("777")) family = "777";
    else if (t.includes("737")) family = "737";
  }
  return `XRM-${m}-${family}`.toUpperCase().replace(/[^A-Z0-9-]/g, "");
}

export function fleetIdentForAircraft(aircraft) {
  if (!aircraft || typeof aircraft !== "object") return "";
  const existing = cleanText(aircraft.ident);
  if (existing && /^XRM-/i.test(existing)) return existing.toUpperCase();
  return fleetIdentKey(aircraft.msn, aircraft.aircraft_type || aircraft.aircraftType, aircraft.aircraft_series);
}

export const MODEL_FAMILY_OPTIONS = Array.from(new Set(Object.values(MODEL_FAMILY_BY_TYPE))).sort((a, b) =>
  a.localeCompare(b)
);
export const ENGINE_FAMILY_OPTIONS = Array.from(new Set(Object.values(ENGINE_FAMILY_BY_MODEL))).sort((a, b) =>
  a.localeCompare(b)
);
